/*eslint-disable */
const $ = window.jQuery = require('jquery');

import appointmentStatusPopup from "../appointment-status-change-popup/index.vue";
import {bus} from '@/main';
import lbilTeleconsulting from '@/components/public/lbil-teleconsulting-form-poup/index.vue';
import loader from '@/components/common/component-small-loader';
import {
  mapGetters,
} from 'vuex';
import messageListOfPatient from "../message-of-patient/index.vue";
import toast from '@/services/toast';

var checkConsultPatientState;
export default {
  name: 'consult-dashboard',
  components: {
    'appointment_status-popup' : appointmentStatusPopup,
    'message-list-patient' : messageListOfPatient,
    loader,
    'lbil-teleconsulting':lbilTeleconsulting
  },
  props: [],
  data () {
    return {
      consultPatientList:null,
      consultPatientListResults:[],
      activeConsultPatient:'',
      consultPatientInfoFStep:false,
      consultPatientInfo:null,
      consultInfoTabs:'patientInfo',
      patientDetailsLoader:false,
      appointmentStatusPopup:false,
      appointmentStatusForData:{},
      messageListOfPatientPopup:false,
      appointmentStatusForFlag:'',
      lbilTeleconsultingState:false,
      selfUserInfo:null,
    }
  },
  computed: {
    ...mapGetters([
      'getconsultPatientGetters',
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getConsultPatientListFun(){
      this.consultPatientList = this.$store.getters.getconsultPatientGetters.data;
      return
    },
    setIntialStateOfConsultPatient(){
      if(this.consultPatientList){
        this.consultPatientListResults = this.consultPatientList.data
      }
      return
    }
  },
  mounted () {
    this.getConsultPatientListFun
    this.setIntialStateOfConsultPatient
    this.getSelfUserInfoFun
    // Active First Item Of Consult Patient List
    var checkConsultPatientState = setInterval(() => {
      if(this.consultPatientListResults.length > 0){
        document.getElementsByClassName("consult_patient_list_item")[0].click()
        clearInterval(checkConsultPatientState)
      }
    },200)
    bus.$on('lbilTeleconsultingStateBus', (data) => {
      this.lbilTeleconsultingState = data
    });
    bus.$on('appointmentStatusPopupBus', (data) => {
      this.appointmentStatusPopup = data
    });
    bus.$on('consultPatientInfoBus', (data) => {
      this.consultPatientInfo = data
    });
    bus.$on('messageListOfPatientPopupBus', (data) => {
      this.messageListOfPatientPopup = data
    });
  },
  methods: {
    lbilTeleconsultingOpenPopup(){
      $('body').addClass('body_right_scroll_remove')
      this.lbilTeleconsultingState = true
    },
    messageListOfPatientPopupmethod(){
      document.body.classList.add('body_right_scroll_remove')
      this.messageListOfPatientPopup = true
    },
    consultPatientTabMethod(ID){
      this.patientDetailsLoader =  true
      this.activeConsultPatient = ID
      this.$store.dispatch('getconsultPatientDetailyIdMethod', {id:ID}).then((res) => {
        this.consultInfoTabs = 'patientInfo'
        this.consultPatientInfoFStep = false
        this.consultPatientInfo =  res.data.data.data
        this.patientDetailsLoader =  false
      }).catch((err)=>{
        this.patientDetailsLoader =  false
      })
    },
    consultInfoTabsMethod(tab){
      this.consultInfoTabs = tab
    },
    appointmentStatusUpdatedFun(data, flag){
      this.appointmentStatusPopup = true
      this.appointmentStatusForData = data
      this.appointmentStatusForFlag = flag
    }
  },
  watch: {
    getConsultPatientListFun(){
      return this.$store.getters.getconsultPatientGetters
    },
    setIntialStateOfConsultPatient(){
      if(this.consultPatientList){
        this.consultPatientListResults = this.consultPatientList.data
      }
      return
    },
    getSelfUserInfoFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
  },
  beforeRouteLeave: function (to, from, next) {
    clearInterval(checkConsultPatientState)
    next();
  },
}